import React from "react";
import './components/Todo.css'



export default function Header(props){

    return(
        <>
            
            <header>
                <h1>{props.header}</h1>
            </header>
            <p id="aviso">{props.mesege}</p>
        </>
    )

}